import React from 'react';
import styled from 'styled-components';

const STEP = styled.div`
  background-image:  linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
  color: #fff;
`; 
// 入塾の流れのカードを作成する
const FlowText = (props) => {
      // お問い合わせボタン
      const btnTitle = props.btnTitle;  
      
      // 詳細の案内
      const detail = props.detail;  

      return (
        <div className="card center mt-5" >

            <STEP className="card-header">
                STEP.{props.id} 
            </STEP>

            <div className="card-body">
                <h2 className="card-title">{props.title}</h2>

                <p className="card-text">{props.text1}
                {/* 詳細の案内 */}
                  {detail !=undefined && 
                    <a href={props.urlAddress}>{detail}</a>
                  }
                </p>


                {/* ボタン(お問い合わせだけ表示) */}
                  {btnTitle !=undefined && 
                  <a href={props.urlAddress} className={props.btn} target="_blank">{btnTitle}</a>
                  }
               
                <p className="card-text">{props.text2}</p>
                <p className="card-text">{props.text3}</p>

            </div>
        </div>
      );
    };

export default FlowText;